import axios from 'axios';

// api remote server

export const getAddresType = () => axios.get(`/mothers/getaddresstype`);
export const getCitizenShip = () => axios.get(`/mothers/getcitizenship`);
export const getDocumentType = () => axios.get(`/mothers/getdocumenttype`);
export const getGender = () => axios.get(`/mothers/getgender`);
export const getRegion = () => axios.get(`/mothers/getregion`);
export const getRelation = () => axios.get(`/mothers/getrelation`);
export const getStreet = district =>
  axios.get(`/mothers/getstreet/${district}`);
export const getDistrict = id => axios.get(`/mothers/getdistrict/${id}`);
export const getCity = district =>
  axios.get(`/mothers/getlocality/${district}`);
export const getIndex = district =>
  axios.get(`/mothers/getpostindex/${district}`);

export const getReasonsRefusal = () => axios.get(`/mothers/getrefuse`);
export const getCancel = () => axios.get(`/mothers/getcancel`);

export const getSubmitterType = () => axios.get(`/mothers/getsubmittertype`);
export const getBanks = distr => axios.get(`/mothers/getbank/${distr}`);
export const getIndivent = () => axios.get(`/mothers/getindivent`);
export const getLegalActivity = () => axios.get(`/mothers/getlegalactivity`);
export const getFreqPayment = () => axios.get(`/mothers/getfreqpayment`);

export const getChildData = data => axios.post(`/mothers/savechild`, data);

export const getChildrenDataTable = id =>
  axios.get(`/mothers/getChildren/${id}`);

export const uploadDocument = data => axios.get(`/mothers/upload`, data);
export const getAgrimantData = id => axios.get(`/mothers/getAgreement/${id}`);
export const getPaymantData = (id, district) =>
  axios.get(`/mothers/getPayment/${id}/${district}`);

// export const deleteChild = id => axios.get(`/mothers/delChildren/${id}`);

//applicant
// export const getApplicant = applData =>
//   axios.post(`/mothers/getApplicant`, applData);
//aplication data
export const getApplicationDatat = id =>
  axios.get(`/mothers/getApplication/${id}`);
//get flags
export const getFlagsData = () => axios.get(`/mothers/getflags`);
//get shildren
export const getChildrenInfo = data => axios.post(`/mothers/getChildren`, data);
//login user
export const loginUserSigned = userData =>
  axios.post(`/mothers/generate-token`, { signed: userData });
//save children
export const saveChildrenService = formData =>
  axios.post(`/mothers/saveChildScan/`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
//save application
export const saveApplicationService = (
  applicationID,
  applicantID,
  subdivision
) =>
  axios.get(
    `/mothers/saveApplication/${applicationID}/${applicantID}/${subdivision}`
  );
//save agriment
export const saveAgreementService = agriment =>
  axios.post(`/mothers/saveAgreement`, agriment);
//view declaretion html
export const getDeclarationService = id =>
  axios.get(`/mothers/getDeclaration/${id}`);
//save paymant scan
export const savePaymantScan = data =>
  axios.post(`/mothers/savePaymentScan/`, data);
//delete paymant scan
export const deletePaymantScan = id => axios.get(`/mothers/delPayment/${id}`);
//save Applicant
export const saveApplicantService = data =>
  axios.post('/mothers/saveApplicant', data);
//send application
//export const changeStateSendApplication = (id, status) => axios.get(`/mothers/setState/${id}/${status}`)
//send application
export const changeStateSendApplication = data =>
  axios.post(`/mothers/setState`, data);
//save application scan
export const saveApplicationScan = data =>
  axios.post(`/mothers/multipleSave`, data);
export const saveSelectedChildren = (id, arr) =>
  axios.post(`/mothers/childtoagr/${id}`, { arr });
//delete application
export const deleteApplication = id =>
  axios.get(`/mothers/delApplication/${id}`);
export const saveChildrenScanService = data =>
  axios.post(`/mothers/saveChildScan`, data);

export const getChildrenForSelect = id =>
  axios.get(`/mothers/getChildrenarray/${id}`);

export const getChildrenByApplication = id =>
  axios.get(`/mothers/getChildAgr/${id}`);

export const deleteChildrenByApplication = (id, idagr) =>
  axios.get(`/mothers/delchildfromagreement/${id}/${idagr}`);
export const deleteScanByApplication = (id, file) =>
  axios.get(`/mothers/delagreementscan/${id}/${file}`);

export const deleteAgreemant = id => axios.get(`/mothers/delAgreement/${id}`);

//getAllApplications
// FOP
//gets data
export const getDictionary = name => axios.get(`/fop/getDict/${name}`);

export const getAllApplications = id =>
  axios.get(`/fop/getApplicationList/${id}`);

export const getApplication = id => axios.get(`/fop/getApplication/${id}`);

export const getDocument = id => axios.get(`/fop/getDocument/${id}`);

export const getCancelDocument = () => axios.get(`/fop/getCancel`);

export const getBankbyIban = iban => axios.get(`/fop/getBankbyIban/${iban}`);

export const getChildren = id => axios.get(`/fop/getChildren/${id}`);

export const gerChild = id => axios.get(`/fop/getChild/${id}`);

export const deleteChild = id => axios.get(`/fop/delChild/${id}`);

export const getFiles = id => axios.get(`/fop/getFiles/${id}`);

export const delFile = data => axios.post(`/fop/delFile`, data);

export const getFile = data => axios.post(`/fop/getFile`, data);

export const StopAssistance = data => axios.post(`/fop/StopAssistance`, data);

export const setSpecialFlags = data =>
  axios.post(`/fop/setSpecialFlags `, data);

// save data
export const saveApplicant = data => axios.post('/fop/setApplicant', data);
export const savePassport = data => axios.post('/fop/setPassport', data);
export const saveAddress = data => axios.post('/fop/setAddress', data);
export const saveChild = data => axios.post('/fop/setChild', data);
export const saveBank = data => axios.post('/fop/setBank', data);
export const aproveApp = data => axios.post('/fop/aproveApp', data);
export const saveFiles = formData =>
  axios.post(`/fop/saveFile`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
